import React from "react";

/**
 * Render a scrolling list of chat bubbles + suggested prompts + error banner.
 * Presentation-only — parent owns state (messages, streaming, error, onSuggest).
 */
export default function ChatMessages({ bodyRef, messages, streaming, error, suggestions, onSuggest }) {
  return (
    <div ref={bodyRef} className="flex-1 overflow-y-auto px-5 py-5 space-y-4" data-testid="chat-body">
      {messages.map((m, i) => (
        <ChatBubble
          key={m.id}
          role={m.role}
          content={m.content}
          streaming={streaming && i === messages.length - 1 && m.role === "assistant"}
        />
      ))}
      {messages.length === 1 && suggestions?.length > 0 && (
        <div className="pt-2 flex flex-wrap gap-2" data-testid="chat-suggestions">
          {suggestions.map((s) => (
            <button
              key={s}
              onClick={() => onSuggest(s)}
              className="text-xs text-[#D8A936] border border-[#D8A936]/50 px-3 py-1.5 hover:bg-[#D8A936]/10 transition-colors text-left"
            >
              {s}
            </button>
          ))}
        </div>
      )}
      {error && (
        <div className="text-xs text-red-400 border border-red-500/40 bg-red-500/10 px-3 py-2" data-testid="chat-error">
          {error}
        </div>
      )}
    </div>
  );
}

function ChatBubble({ role, content, streaming }) {
  const isUser = role === "user";
  return (
    <div className={`flex ${isUser ? "justify-end" : "justify-start"}`} data-testid={`chat-bubble-${role}`}>
      <div
        className={`max-w-[85%] px-4 py-3 leading-relaxed text-[14px] ${
          isUser ? "bg-[#D8A936] text-[#0B0B0C]" : "bg-[#151517] border border-[#343437] text-[#FAF9F6]"
        }`}
      >
        {content || (streaming ? <TypingDots /> : null)}
        {streaming && content && (
          <span className="inline-block w-2 h-4 ml-0.5 bg-[#D8A936] animate-pulse align-middle" />
        )}
      </div>
    </div>
  );
}

function TypingDots() {
  return (
    <span className="inline-flex items-center gap-1" aria-label="thinking">
      <span className="w-1.5 h-1.5 bg-[#D8A936] rounded-full animate-bounce" style={{ animationDelay: "0ms" }} />
      <span className="w-1.5 h-1.5 bg-[#D8A936] rounded-full animate-bounce" style={{ animationDelay: "150ms" }} />
      <span className="w-1.5 h-1.5 bg-[#D8A936] rounded-full animate-bounce" style={{ animationDelay: "300ms" }} />
    </span>
  );
}
